import { evaluateMarker } from "./rooms";

const CRITICAL = new Set(["kitchen", "pooja", "master_bedroom", "entrance", "toilet"]);
const POINTS = { ideal: 100, ok: 60, conflict: 0 };

// Weighted Vastu compliance score (0-100). Critical rooms count double.
export function computeScore(markers, center, rotation) {
  const evals = markers.map((m) => ({ marker: m, ...evaluateMarker(m, center, rotation) })).filter((e) => e.status !== "unknown");
  if (evals.length === 0) return { score: null, grade: null, evals, counts: { ideal: 0, ok: 0, conflict: 0 }, remedies: [] };
  let total = 0, weight = 0;
  const counts = { ideal: 0, ok: 0, conflict: 0 };
  for (const e of evals) {
    const w = CRITICAL.has(e.room.id) ? 2 : 1;
    total += POINTS[e.status] * w;
    weight += w;
    counts[e.status] += 1;
  }
  const score = Math.round(total / weight);
  const remedies = evals
    .filter((e) => e.status === "conflict")
    .sort((a, b) => (CRITICAL.has(b.room.id) ? 1 : 0) - (CRITICAL.has(a.room.id) ? 1 : 0))
    .slice(0, 3)
    .map((e) => ({ room: e.room.label, direction: e.direction, sanskrit: e.info.sanskrit, ideal: e.room.ideal.join("/"), remedy: e.room.remedy }));
  return { score, grade: gradeFor(score), evals, counts, remedies };
}

export function gradeFor(score) {
  if (score >= 90) return { label: "Excellent", color: [16, 185, 129] };
  if (score >= 75) return { label: "Good", color: [59, 130, 246] };
  if (score >= 50) return { label: "Needs attention", color: [245, 158, 11] };
  return { label: "Poor", color: [239, 68, 68] };
}
